<template>
  <el-tree
    :props="props1"
    :load="loadNode1"
    node-key="id"
    lazy
    show-checkbox
    highlight-current
    @check-change="emitNodes"
    :default-expanded-keys="defaultExpandedKeys"
    :default-checked-keys="defaultCheckedKeys"
    ref="tree">
  </el-tree>
</template>

<script>
// import debounce from '@/common/utils'
export default {
  data() {
    return {
      props1: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      },
      defaultExpandedKeys: ['1'],
      defaultCheckedKeys: ['1', '2', '3']
    }
  },
  methods: {
    emitNodes() {
      this.$emit('check-change', this.$refs.tree.getCheckedKeys())
    },
    loadNode1(node, resolve) {
        if (node.level === 0) {
          return resolve([{ name: 'Group A', id: '1' }]);
        }
        if (node.level > 1) return resolve([]);

        setTimeout(() => {
          const data = [{
            name: 'Group B',
            id: '2',
            leaf: true
          }, {
            name: 'Group C',
            id: '3'
          }];

          resolve(data);
        }, 500);
    }
  },
  created() {
    this.emitNodesDd = () => {}
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// src/components/tree.vue